const countReducer = (state = { count: 0 }, action) => {
    switch (action.type) {
      default:
        return state;
    }
  };
  
  export default countReducer;
  